// Shared Indian-mobile phone validator. Mirrors backend validate_phone() in
// backend/server.py — keep the two in sync. Accepts +91 / 91 / 0 prefixes.

const stripToDigits = (phone) => {
  const cleaned = phone.trim().replace(/[\s\-\(\)]+/g, "");
  let digits = cleaned;
  if (digits.startsWith("+91")) digits = digits.slice(3);
  else if (digits.startsWith("91") && digits.length === 12) digits = digits.slice(2);
  else if (digits.startsWith("0")) digits = digits.slice(1);
  return digits;
};

// Returns "" if valid, otherwise a human-readable error message.
export const validatePhone = (phone) => {
  if (!phone || !phone.trim()) return "Phone number is required";
  const digits = stripToDigits(phone);
  if (!/^[6-9]\d{9}$/.test(digits)) return "Please enter a valid 10-digit Indian mobile number";
  return "";
};

// Returns the normalized 10-digit form. Caller should validatePhone() first.
export const formatPhone = (phone) => {
  if (!phone) return "";
  return stripToDigits(phone);
};
